export const enum LeadEmailFormStatechartActionEnum {
  /**
   * Send request to create lead
   */
  sendRequestToCreateLead = 'sendRequestToCreateLead',

  /**
   * Show errors which happened in process of sending lead and auto registering
   */
  showErrors = 'showErrors',

  /**
   * Send auto register request
   */
  sendAutoRegisterRequest = 'sendAutoRegisterRequest',

  /**
   * Show success message popup
   */
  showSuccessMessage = 'showSuccessMessage',

  /**
   * Show sign in message and sign in buttons
   */
  showSignInMessage = 'showSignInMessage',

  /**
   * Execute google captcha
   */
  executeCaptcha = 'executeCaptcha',

  /**
   * Reset recaptcha
   */
  resetCaptcha = 'resetCaptcha',
}
